import axios from 'axios'
import queryString from 'query-string'
import { decamelizeKeys, camelizeKeys } from 'humps'

import type { FetchDailiesParams, FetchDailyParams, Raw } from './types'
import { dailiesParser } from './parsers'

const CONTENT_URL = process.env.CONTENT_URL

export async function fetchDaily(params: FetchDailyParams) {
  const response = await axios
    .get(`${CONTENT_URL}?${queryString.stringify(decamelizeKeys(params))}`)
    .then((response) => (camelizeKeys(response.data) as unknown) as Raw)

  const { dailies } = dailiesParser(response)
  return dailies[0]
}

export async function fetch(params: FetchDailiesParams) {
  const { lastEvaluated = {}, ...restParams } = params
  const response = await axios
    .get(
      `${CONTENT_URL}?${queryString.stringify(
        decamelizeKeys({ ...lastEvaluated, ...restParams }),
      )}`,
    )
    .then((response) => (camelizeKeys(response.data) as unknown) as Raw)

  return dailiesParser(response)
}
